import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import React from 'react';
import { PROFILE_TAB_INDEX } from '@/constants/storage-key';
const SocialTab = dynamic(() => import('../SocialTab'), {
  ssr: false,
});
const GiftTab = dynamic(() => import('../GiftTab'), {
  ssr: false,
});
const PlayTab = dynamic(() => import('../PlayTab'), {
  ssr: false,
});
const TradeTab = dynamic(() => import('../TradeTab'), {
  ssr: false,
});
export const Tabs = dynamic(
  () => import('@chakra-ui/react').then(mod => mod.Tabs),
  {
    ssr: false,
  }
);
export const Tab = dynamic(
  () => import('@chakra-ui/react').then(mod => mod.Tab),
  {
    ssr: false,
  }
);
export const TabList = dynamic(
  () => import('@chakra-ui/react').then(mod => mod.TabList),
  {
    ssr: false,
  }
);
export const TabPanel = dynamic(
  () => import('@chakra-ui/react').then(mod => mod.TabPanel),
  {
    ssr: false,
  }
);
export const TabPanels = dynamic(
  () => import('@chakra-ui/react').then(mod => mod.TabPanels),
  {
    ssr: false,
  }
);
import s from './styles.module.scss';
import { useProfiles } from '@/modules/AlphaPWA/Profiles/provider';
import HolderDetail from '../HolderDetail';
import { useRouter } from 'next/router';

enum TabIndex {
  Social = 0,
  Gift = 1,
  Play = 2,
  Trade = 3,
}

interface IProps {
  setStatusPublicPost?: (status: boolean) => void;
  isScrolledToBottom?: boolean;
}

const Posts: React.FC<IProps> = (props: IProps): React.ReactElement => {
  const {
    query: { id, view },
  } = useRouter();
  const { setIsSticky, tabActive, setTabActive } = useProfiles();
  const { setStatusPublicPost, isScrolledToBottom } = props;
  const [indexTab, setIndexTab] = useState<number>(
    localStorage.getItem(PROFILE_TAB_INDEX)
      ? Number(localStorage.getItem(PROFILE_TAB_INDEX))
      : TabIndex.Social
  );

  useEffect(() => {
    setTabActive(
      localStorage.getItem(PROFILE_TAB_INDEX)
        ? Number(localStorage.getItem(PROFILE_TAB_INDEX))
        : TabIndex.Social
    );
  }, []);

  useEffect(() => {
    localStorage.setItem(PROFILE_TAB_INDEX, tabActive.toString());
    setIsSticky(false);
    setIndexTab(tabActive);
  }, [tabActive]);

  if (view) {
    return <HolderDetail />;
  }

  return (
    <div className={s.postWrapper}>
      <Tabs
        className={s.tabs}
        index={indexTab}
        // onChange={k => {
        //   setIndexTab(k);
        //   setIsSticky(false);
        //   localStorage.setItem(PROFILE_TAB_INDEX, k.toString());
        // }}
      >
        {/*<TabList className={s.tabList}>*/}
        {/*  <Tab className={s.tab}>Social</Tab>*/}
        {/*  <Tab className={s.tab}>Play</Tab>*/}
        {/*  <Tab className={s.tab}>Gift</Tab>*/}
        {/*  <Tab className={s.tab}>Trade</Tab>*/}
        {/*</TabList>*/}

        <TabPanels className={s.tabPanels}>
          <TabPanel className={s.tabPanel}>
            <SocialTab
              setStatusPublicPost={setStatusPublicPost}
              isScrolledToBottom={isScrolledToBottom}
            />
          </TabPanel>
          <TabPanel className={s.tabPanel}>
            <PlayTab
              setStatusPublicPost={setStatusPublicPost}
              isScrolledToBottom={isScrolledToBottom}
            />
          </TabPanel>
          <TabPanel className={s.tabPanel}>
            <GiftTab
              setStatusPublicPost={setStatusPublicPost}
              isScrolledToBottom={isScrolledToBottom}
            />
          </TabPanel>
          <TabPanel className={s.tabPanel}>
            <TradeTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
};

export default Posts;
